var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('tabbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabbarType),expression:"tabbarType"}]}),(_vm.loadingType)?_c('Loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }